<template>
  <div class="rounded-md p-4" :class="mainClasses">
    <div class="flex">
      <div v-if="!noIcon" class="flex-shrink-0">
        <CheckCircleIcon
          v-if="type == 'success'"
          class="h-5 w-5 text-green-400 dark:text-green-200"
          aria-hidden="true"
        />
        <InformationCircleIcon
          v-else-if="type == 'info'"
          class="h-5 w-5 text-blue-400 dark:text-blue-200"
          aria-hidden="true"
        />
        <XCircleIcon
          v-else-if="type == 'error'"
          class="h-5 w-5 text-red-400 dark:text-red-200"
          aria-hidden="true"
        />
        <ExclamationIcon
          v-else-if="type == 'warning'"
          class="h-5 w-5 text-yellow-400 dark:text-yellow-200"
          aria-hidden="true"
        />
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup>
import {
  ExclamationIcon,
  XCircleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
} from '@heroicons/vue/solid'
import { computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'info',
  },
  noIcon: Boolean,
})
const mainClasses = computed(() => {
  return {
    success: 'bg-green-50 dark:bg-green-900',
    info: 'bg-blue-50 dark:bg-blue-900',
    error: 'bg-red-50 dark:bg-red-900',
    warning: 'bg-yellow-50 dark:bg-yellow-900',
  }[props.type]
})
</script>
